import React, { useRef, useEffect } from 'react';

const BookingImageGenerator = ({ bookingDetails, onImageGenerated }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (bookingDetails) {
      generateImage();
    }
  }, [bookingDetails]);

  const generateImage = () => {
    setTimeout(() => {
      try {
        const canvas = canvasRef.current;
        if (!canvas) {
          onImageGenerated('fallback');
          return;
        }
        
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          onImageGenerated('fallback');
          return;
        }
        
        canvas.width = 500;
        canvas.height = 320;
        
        // Background
        ctx.fillStyle = '#f8f9fa';
        ctx.fillRect(0, 0, 500, 280);
        
        // Header
        ctx.fillStyle = '#4a5568';
        ctx.fillRect(0, 0, 500, 60);
        
        ctx.fillStyle = '#ff9900';
        ctx.fillRect(0, 60, 500, 4);
        
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 18px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('Photo Studio Booking', 250, 38);
        
        // Token
        ctx.fillStyle = '#3182ce';
        ctx.font = 'bold 28px Arial';
        ctx.textAlign = 'left';
        ctx.fillText(`Token: ${bookingDetails.tokenNumber}`, 30, 110);
        
        // Details
        ctx.fillStyle = '#2d3748';
        ctx.font = '16px Arial';
        ctx.fillText(`Location: ${bookingDetails.location}`, 30, 145);
        ctx.fillText(`Time Slot: ${bookingDetails.timeSlot}`, 30, 170);
        ctx.fillText(`Arrival Time: ${bookingDetails.arrivalTime}`, 30, 195);
        ctx.fillText(`Booking Date: ${new Date().toLocaleDateString()}`, 30, 220);
        
        // Instructions
        ctx.fillStyle = '#718096';
        ctx.font = '14px Arial';
        ctx.fillText('Please arrive 5 minutes before your time slot', 30, 250);
        ctx.fillText('Show this token at the photo studio', 30, 270);
        
        canvas.toBlob((blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            onImageGenerated(url);
          } else {
            onImageGenerated('fallback');
          }
        }, 'image/png', 1.0);
        
      } catch (error) {
        console.error('Error generating image:', error);
        onImageGenerated('fallback');
      }
    }, 100);
  };

  return <canvas ref={canvasRef} style={{ display: 'none' }} />;
};

export default BookingImageGenerator;